import { supabase } from '@/integrations/supabase/client';
import { BaseAttachedResearch, EntityConfig } from '@/types/research-attachments';
import { buildSelectQuery } from '../utils/query-builders';

/**
 * Fetches research attachments for a given entity
 */
export const fetchAttachments = async <T extends BaseAttachedResearch>(
  config: EntityConfig,
  entityId: string
): Promise<T[]> => {
  if (!entityId) return [];

  // DISABLED: Workbook research system not implemented
  if (config.entityType === 'workbook') {
    console.log('[fetchAttachments] Workbook research disabled - returning empty array');
    return [];
  }

  const selectQuery = buildSelectQuery(config);

  const { data, error } = await supabase
    .from(config.tableName as any)
    .select(selectQuery)
    .eq(config.entityIdColumn, entityId)
    .order('created_at', { ascending: false });

  if (error) {
    console.error(`Error fetching ${config.entityType} research attachments:`, error);
    throw error;
  }

  if (!data || !Array.isArray(data)) {
    return [];
  }

  return data as unknown as T[];
};
